import React from "react";
import { InfiniteBeta } from "./InfiniteBeta";
import { Skajillion } from "./Skajillion";
import { WhatzBlue } from "./WhatzBlue";
import { Stories } from "./Stories";
import { Executioners } from "./Executioners";

const panel = (bg) => ({
  flex: 1,
  ...(bg ? { backgroundImage: `url('${bg}')` } : {}),
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
});

export const Pick5 = ({ active = false, getSlideNumber, updateActiveSlide }) => {
  return (
    <div id="pick-5" className={`${active ? "active " : ""}item`}>
      <div
        className="white-text text-center"
        style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}
      >
        <div
          className="pick5-panel"
          style={{ ...panel(null), backgroundColor: "#cccccc" }}
          onClick={() => updateActiveSlide(getSlideNumber(InfiniteBeta))}
        >
          <img
            src="/images/infinitebeta_2.svg"
            style={{ height: "12vh", width: "auto" }}
            alt="Infinite Beta"
          />
        </div>

        <div
          className="pick5-panel"
          style={panel("/images/full_page/skajillion.jpg")}
          onClick={() => updateActiveSlide(getSlideNumber(Skajillion))}
        >
          <h1 id="skajillion-story" className="slide-link no-top-bottom-margin">
            <img
              src="/images/skajillion-logo-head_white.png"
              style={{ width: "50%", height: "auto" }}
              alt="Skajillion"
            />
          </h1>
          <p style={{ marginTop: "-15px" }}>Sustainable Social Media</p>
        </div>

        <div
          className="pick5-panel av-next-condensed-ulight"
          style={panel("/images/full_page/whatzblue.jpg")}
          onClick={() => updateActiveSlide(getSlideNumber(WhatzBlue))}
        >
          <h1
            id="whatz-blue-story"
            className="slide-link no-top-bottom-margin"
            style={{ color: "#fff" }}
          >
            WHATZBLUE
          </h1>
        </div>

        <div
          className="pick5-panel"
          style={panel("/images/full_page/stories.jpg")}
          onClick={() => updateActiveSlide(getSlideNumber(Stories))}
        >
          <h2
            id="stories-story"
            className="slide-link no-top-bottom-margin"
            style={{ color: "#fff" }}
          >
            stories
          </h2>
        </div>

        <div
          className="pick5-panel av-next-condensed-reg"
          style={panel("/images/full_page/execution.jpg")}
          onClick={() => updateActiveSlide(getSlideNumber(Executioners))}
        >
          <h3
            id="executioners-story"
            className="slide-link no-top-bottom-margin"
            style={{ color: "#fff" }}
          >
            execution/executioners
          </h3>
        </div>
      </div>
    </div>
  );
};

Pick5.slideName = "Pick5";
Pick5.pathname = "/";
